import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import CommentsShared from '@hubins/components/Comments';

type CommentsProps = {
  model: string;
  modelUuid: string;
  presetChannels?: string[];
  title?: string;
}

const Comments = (props: CommentsProps) => {
  const { user } = useAuth();
  
  return (
    <CommentsShared
      {...props}
      userUuid={user.uuid}
    />
  );
};

export default Comments;
